import firebase from "firebase"

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDjlvTwnCNGP4SsS8JQGXrQiEGiKgf1ewA",
  authDomain: "physio-point.firebaseapp.com",
  projectId: "physio-point",
  storageBucket: "physio-point.appspot.com",
  messagingSenderId: "789658051513",
  appId: "1:789658051513:web:8b8e23421499dedab14c68",
  measurementId: "G-YFVDQNQF0J"
};

  export default firebase.initializeApp(firebaseConfig);